import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'wm-map-services-editor',
    templateUrl: './map-services-editor.component.html',
    styleUrls: ['./map-services-editor.component.css'],
    standalone: false
})
export class MapServicesEditorComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
